<script>
  import SmallTitle from '../common/SmallTitle.svelte';
  import ButtonLink from '../common/ButtonLink.svelte';
  import Button from '../common/Button.svelte';
  import ConfirmModal from '../common/ConfirmModal.svelte';
  import Common from '../js/common';

  export let value;
  export let lang = undefined;
  export let user;

  let displayConfirmModal = false;
  let confirmModalMessage;
  let messageBox;

  async function deleteDailyBulletin () {
    messageBox = {
      cs: { color: 'blue', message: i18n.deletingInProgress.cs },
      en: { color: 'blue', message: i18n.deletingInProgress.en },
    };

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/admin/dailyBulletins/delete/${value.id}`);

    if (response.ok) {
      window.location.reload();
    } else {
      messageBox = {
        cs: { color: 'red', message: i18n.unexpectedError.cs },
        en: { color: 'red', message: i18n.unexpectedError.en },
      };
    }
  }

  if (user) {
    confirmModalMessage = {
      cs: `Opravdu chcete smazat denní zpravodaj "[${Common.addZeros(value.id)}] ${value.code}"?`,
      en: `Do you really want to delete daily bulletin "[${Common.addZeros(value.id)}] ${value.code}"?`,
    };
  }

  const i18n = {
    dailyBulletin: {
      cs: 'Denní zpravodaj',
      en: 'Daily bulletin',
    },
    dailyReport: {
      cs: 'Denní hlášení',
      en: 'Daily report',
    },
    edit: {
      cs: 'Upravit',
      en: 'Edit',
    },
    delete: {
      cs: 'Smazat',
      en: 'Delete',
    },
    deletingInProgress: {
      cs: 'Probíhá mazání denního zpravodaje...',
      en: 'Daily bulletin deleting in progress...',
    },
    unexpectedError: {
      cs: '(Ne)očekávaná chyba. `E29`',
      en: '(Un)expected error. `E29`',
    },
  };
</script>

<div class='daily-bulletin'>
  <div class='daily-bulletin-small-title'>
    <SmallTitle value={value.name[lang]} append={value.date}/>
  </div>

  <div class='daily-bulletin-content'>
    <ButtonLink value={i18n.dailyBulletin[lang]} icon='description'
      link={`./file/dailyBulletin/${value.code}.pdf?t=${Common.getDbDate() + Common.getDbTime()}`}/>

    {#if value.dailyReport}
      <ButtonLink value={i18n.dailyReport[lang]} icon='library_books'
        link={value.dailyReport}/>
    {/if}
  </div>

  {#if user}
    <div class='daily-bulletin-admin'>
      <Button value={i18n.edit[lang]} icon='edit' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
        onClick={() => { window.location.href = `./#/admin/daily-bulletins/${value.code}`; }}/>

      <Button value={i18n.delete[lang]} icon='delete' admin={true} disabled={!user.roles.includes('ROLE_ADMIN')}
        onClick={() => { displayConfirmModal = true; }}/>
    </div>
  {/if}
</div>

{#if user}
  <ConfirmModal bind:display={displayConfirmModal} message={confirmModalMessage[lang]}
    onConfirm={deleteDailyBulletin} messageBox={messageBox ? messageBox[lang] : undefined} bind:lang/>
{/if}

<style>
  .daily-bulletin {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .daily-bulletin-content {
    display: flex;
    gap: 20px;
  }

  .daily-bulletin-admin {
    display: flex;
    gap: 20px;
  }

  @media only screen and (max-width: 600px) {
    .daily-bulletin-content {
      flex-direction: column;
    }

    .daily-bulletin-admin {
      flex-direction: column;
    }
  }
</style>
